import { useState, useEffect } from "react";
import DeleteIcon from "@mui/icons-material/Delete";
import {
  Typography,
  Box,
  Tooltip,
  IconButton,
  Button,
  Checkbox,
  TextField,
  DialogContent,
  DialogActions,
  Dialog,
  DialogTitle,
  DialogContentText,
} from "@mui/material";
import { DataGrid, faIR } from "@mui/x-data-grid";
import { UsePaymentManagment } from "./UsePaymentManagment";
import { UseMyPC } from "../../hooks/UseMyPC";
import CustomPagination from "../../components/CustomPagination";
import ProgressCom from "../../components/ProgressCom";
import Detail from "../../main/detail/Detail";
import { deCapitalizeFirstLetter, toMoney } from "../../util/Utils";
import { rsProgress, rsActiveMenu, rsGotoLast } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import { useNavigate, useLocation } from "react-router-dom";
import { useSnackbar } from "notistack";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import CheckIcon from "@mui/icons-material/Check";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import EditIcon from "@mui/icons-material/Edit";

export default function PaymentManagment() {
  const navigate = useNavigate();
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const location = useLocation();
  const [progress, setProgress] = useRecoilState(rsProgress);
  const [paymentssRes, setPaymentsRes] = useState();
  const { getPaymentManagment, UpdatePaymentManagment } = UsePaymentManagment();
  const [openDialog, setOpenDialog] = useState({
    show: false,
    model: undefined,
  });

  const [pageState, setPageState] = useState({
    page: 1,
  });

  useEffect(() => {
    setProgress(true);
    getPaymentManagment((Payments) => {
      setPaymentsRes(Payments);
    }, true);
  }, []);

  const columns = [
    {
      field: "id",
      width: 80,
      align: "center",
      headerName: "id",
      headerAlign: "center",
      hide: true,
    },
    {
      field: "index",
      width: 80,
      align: "center",
      headerName: "ردیف",
      headerAlign: "center",
      sortable: false,
    },
    {
      field: "payment",
      headerName: "روش پرداخت",
      width: 200,
      align: "center",
      sortable: false,
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography variant="body2" sx={{ whiteSpace: "normal" }}>
            {cellValues.row.payment}
          </Typography>
        );
      },
    },

    {
      field: "enable",
      headerName: "وضعیت",
      width: 90,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Box>
            {cellValues.row.enable ? (
              <CheckIcon style={{ color: "#618833" }} />
            ) : (
              <CloseOutlinedIcon style={{ color: "red" }} />
            )}
          </Box>
        );
      },
    },
    {
      field: "عملیات",
      sortable: false,
      width: 230,
      headerAlign: "center",
      align: "center",
      headerName: "عملیات",
      renderCell: (cellValues) => {
        return (
          <>
            <Tooltip title="Edit">
              <IconButton
                onClick={() => {
                  return navigate("/paymentmanagment/editPayment", {
                    state: {
                      model: cellValues.row,
                    },
                  });
                }}
              >
                <EditIcon fontSize="small" sx={{ color: "MyColor.main" }} />
              </IconButton>
            </Tooltip>
            <IconButton
              sx={{ p: 0.5, mr: 0.5 }}
              onClick={() => {
                let model = {
                  id: cellValues.row.id,
                  index: cellValues.row.index - 1,
                  enable: cellValues.row.enable,
                };
                if (cellValues.row.index - 1 == 0) {
                  return;
                } else {
                  setProgress(true);
                  UpdatePaymentManagment(model, "", () => {
                    getPaymentManagment((Payments) => {
                      setPaymentsRes(Payments);
                    }, false);
                  });
                }
              }}
            >
              <ArrowDropUpIcon fontSize="small" />
            </IconButton>
            <IconButton
              sx={{ p: 0.5 }}
              onClick={() => {
                let model = {
                  id: cellValues.row.id,
                  index: cellValues.row.index + 1,
                  enable: cellValues.row.enable,
                };

                if (cellValues.row.index + 1 == paymentssRes.length + 1) {
                  return;
                } else {
                  setProgress(true);
                  UpdatePaymentManagment(model, "", () => {
                    getPaymentManagment((Payments) => {
                      setPaymentsRes(Payments);
                    }, false);
                  });
                }
              }}
            >
              <ArrowDropDownIcon fontSize="small" />
            </IconButton>
            <Box sx={{ ml: 1 }}>
              {cellValues.row.enable ? (
                <Button
                  onClick={() => {
                    setOpenDialog({
                      show: true,
                      model: {
                        id: cellValues.row.id,
                        payment: cellValues.row.payment,
                        enable: false,
                        index: cellValues.row.index,
                      },
                    });
                  }}
                  variant="contained"
                  color="error"
                >
                  غیرفعال
                </Button>
              ) : (
                <Button
                  onClick={() => {
                    setOpenDialog({
                      show: true,
                      model: {
                        id: cellValues.row.id,
                        payment: cellValues.row.payment,
                        enable: true,
                        index: cellValues.row.index,
                      },
                    });
                  }}
                  variant="contained"
                >
                  فعال
                </Button>
              )}
            </Box>
          </>
        );
      },
    },
  ];

  return (
    <Detail
      breadChilds={{
        title: "سفارشات",
        childs: [
          {
            name: msActiveMenu.pageTitle,
            url: "/paymentmanagment",
          },
        ],
      }}
    >
      <Dialog
        PaperProps={{
          elevation: 1,
        }}
        fullWidth
        open={openDialog.show}
        onClose={() => setOpenDialog({ ...openDialog, show: false })}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle color="red" id="alert-dialog-title">
          توجه!
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            آیا از{" "}
            {openDialog.show && !openDialog.model.enable ? "غیرفعال" : "فعال"}{" "}
            کردن روش پرداخت اطمینان دارید ؟
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            sx={{ color: "#565656 !important" }}
            onClick={() => {
              UpdatePaymentManagment(openDialog.model, "", () => {
                getPaymentManagment((Payments) => {
                  setOpenDialog({ ...openDialog, show: false });
                  setPaymentsRes(Payments);
                }, false);
              });
            }}
          >
            بله
          </Button>
          <Button
            color="secondary"
            onClick={() => setOpenDialog({ ...openDialog, show: false })}
          >
            خیر
          </Button>
        </DialogActions>
      </Dialog>
      {paymentssRes ? (
        <DataGrid
          className="ltr-grid"
          localeText={faIR.components.MuiDataGrid.defaultProps.localeText}
          columns={columns}
          rows={paymentssRes ? paymentssRes : []}
          page={pageState.page - 1}
          pageSize={20}
          Pagination
          onPageChange={(newPage) => {
            setPageState((old) => ({ ...pageState, page: newPage + 1 }));
          }}
          rowCount={paymentssRes.length ? paymentssRes.length : "1"}
          enableRangeSelection={true}
          disableColumnMenu
          hideFooterSelectedRowCount
          components={{
            Pagination: CustomPagination,
          }}
          componentsProps={{
            pagination: {
              isLtr: true,
              nofab: true,
              rowCount:
                paymentssRes && paymentssRes.length ? paymentssRes.length : "",
            },
          }}
        />
      ) : (
        <ProgressCom></ProgressCom>
      )}
    </Detail>
  );
}
